import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  FORSUBMIT,
  GET,
  CLEAR,
  CALCULATE_BY_DAYS,
  CLEAR_COSTS
} from '@hobs/constants/tickets';

class Tickets extends BaseReducer {
  static defaultState = {
    tickets: {
      tickets: []
    },
    forSubmit: {
      hnUsersForAssignment: [],
      sendingNationsForCreate: []
    },
    calculateByDays: null
  };
  constructor() {
    super(Tickets.defaultState);

    this.actionMap = {
      [GET.SUCCESS]: this.addTicket,
      [FORSUBMIT.SUCCESS]: this.getForSubmit,
      [CLEAR.SUCCESS]: this.clearTicket,
      [CALCULATE_BY_DAYS.SUCCESS]: this.addCalculateByDaysResults,
      [CLEAR_COSTS.SUCCESS]: this.clearCalculateByDaysResults
    };
  }

  getForSubmit = (state, action) => {
    return Object.assign({}, state, {
      forSubmit: action.response
    });
  };

  addTicket = (state, action) => {
    return Object.assign({}, state, { tickets: action.response });
  };

  clearTicket = state => {
    return Object.assign({}, state, { tickets: { tickets: [] } });
  };

  addCalculateByDaysResults = (state, action) => {
    return Object.assign({}, state, { calculateByDays: action.response });
  };

  clearCalculateByDaysResults = state => {
    return Object.assign({}, state, { calculateByDays: null });
  };
}
export default new Tickets().reducer;
